unable to read source [project]/packages/react/src/__styles.ts